define('deepObject/util',[], function() {
	var rebrackets = /\[(\d+)\]/g,
		reemptydot = /^\./;

    return {
        getProps: function( prop ) {
	        return prop.replace(rebrackets, '.$1').replace(reemptydot, '').split('.');
		}
	};
});
